var React = require('react');

function Webring (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"webring"),React.createElement("g",{"stroke":"currentColor","strokeWidth":"28","fill":"none","fillRule":"evenodd","strokeLinecap":"square","key":1},[React.createElement("path",{"d":"M70.038 166.32c16.569 28.698 53.264 38.53 81.962 21.962 28.698-16.569 38.53-53.264 21.962-81.961l-50-86.603","key":0}),React.createElement("path",{"d":"M173.962 164.68c16.568-28.698 6.736-65.393-21.962-81.962-28.698-16.569-65.393-6.736-81.962 21.961l-50 86.603","key":1}),React.createElement("path",{"d":"M121 75c-33.137 0-60 26.863-60 60s26.863 60 60 60h100","key":2})])]);
}

Webring.defaultProps = {"width":"235","height":"211","viewBox":"0 0 235 211"};

module.exports = Webring;

Webring.default = Webring;
